import React from "react";
import logo from "./Avanade Color Logo RGB.png";
export default function AvanadeLogo() {
    return (
        <div style={{ paddingTop: "0.2rem", cursor: "pointer" }}>
            <div>
                <img alt="Avanade" height={50} src={logo} />
            </div>
        </div>
    );
}
